// extracted by mini-css-extract-plugin
export default {"container":"ConfirmQrRequestModal_container__ljIlI","icon":"ConfirmQrRequestModal_icon__Bw7cj","text":"ConfirmQrRequestModal_text__wnXkI"};